/**
 * Sidebar Calendar Component
 * サイドバーカレンダーの描画と操作を管理
 */
class SidebarCalendar {
  constructor(element) {
    this.element = element;
    this.currentDate = new Date();
    this.closedDates = this.parseClosedDates(element.dataset.closedDates || '');
    this.startWeek = element.dataset.startWeek || 'sun';
    
    this.monthElement = element.querySelector('[data-cal-month]');
    this.gridElement = element.querySelector('[data-cal-grid]');
    this.prevButton = element.querySelector('[data-cal-prev]');
    this.nextButton = element.querySelector('[data-cal-next]');
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.render();
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.previousMonth());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextMonth());
    }
  }

  parseClosedDates(closedDatesString) {
    if (!closedDatesString) return [];
    
    return closedDatesString.split(',').map(date => {
      const trimmed = date.trim();
      return trimmed ? new Date(trimmed) : null;
    }).filter(date => date && !isNaN(date.getTime()));
  }

  previousMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    this.render();
  }

  nextMonth() {
    this.currentDate.setMonth(this.currentDate.getMonth() + 1);
    this.render();
  }

  render() {
    this.renderMonthTitle();
    this.renderCalendar();
  }

  renderMonthTitle() {
    if (this.monthElement) {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth() + 1;
      this.monthElement.textContent = `${year}年${month}月`;
    }
  }

  renderCalendar() {
    if (!this.gridElement) return;

    const year = this.currentDate.getFullYear();
    const month = this.currentDate.getMonth();
    
    // 月の最初の日と最後の日
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    
    // 週の開始日を設定（日曜日=0, 月曜日=1）
    const startWeekDay = this.startWeek === 'mon' ? 1 : 0;
    
    // カレンダーの開始日（前月の日付を含む）
    const calendarStart = new Date(firstDay);
    const firstDayWeekday = firstDay.getDay();
    const daysToSubtract = (firstDayWeekday - startWeekDay + 7) % 7;
    calendarStart.setDate(firstDay.getDate() - daysToSubtract);
    
    // グリッドをクリア
    this.gridElement.innerHTML = '';
    
    // 42セル（6週間）を生成
    for (let i = 0; i < 42; i++) {
      const cellDate = new Date(calendarStart);
      cellDate.setDate(calendarStart.getDate() + i);
      
      const cell = this.createCalendarCell(cellDate, month);
      this.gridElement.appendChild(cell);
    }
  }

  createCalendarCell(date, currentMonth) {
    const cell = document.createElement('div');
    cell.className = 'sidebar-calendar__cell';
    cell.textContent = date.getDate();
    
    const today = new Date();
    const isToday = this.isSameDate(date, today);
    const isCurrentMonth = date.getMonth() === currentMonth;
    const isClosed = this.isClosedDate(date);
    
    // クラスを追加
    if (isToday) {
      cell.classList.add('is-today');
    }
    
    if (isClosed) {
      cell.classList.add('is-closed');
    }
    
    if (!isCurrentMonth) {
      cell.classList.add('is-out');
    }
    
    return cell;
  }

  isSameDate(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

  isClosedDate(date) {
    return this.closedDates.some(closedDate => this.isSameDate(date, closedDate));
  }
}

// 初期化関数
function initSidebarCalendars() {
  const calendarElements = document.querySelectorAll('[data-calendar]');
  calendarElements.forEach(element => {
    // 既に初期化済みの場合はスキップ
    if (element.sidebarCalendar) return;
    
    element.sidebarCalendar = new SidebarCalendar(element);
  });
}

// DOM読み込み完了時に初期化
document.addEventListener('DOMContentLoaded', initSidebarCalendars);

// Shopifyセクションの動的更新に対応
document.addEventListener('shopify:section:load', (event) => {
  const section = event.target;
  const calendarElement = section.querySelector('[data-calendar]');
  
  if (calendarElement) {
    // 既存のインスタンスをクリア
    if (calendarElement.sidebarCalendar) {
      calendarElement.sidebarCalendar = null;
    }
    
    // 新しいインスタンスを作成
    calendarElement.sidebarCalendar = new SidebarCalendar(calendarElement);
  }
});

// セクションがアンロードされた時のクリーンアップ
document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target;
  const calendarElement = section.querySelector('[data-calendar]');
  
  if (calendarElement && calendarElement.sidebarCalendar) {
    calendarElement.sidebarCalendar = null;
  }
});
